import _Abstract from "system/abstract"

export default class BackToTop extends _Abstract {

  constructor(el, options)
  {
    super(el, $.extend(true, {
      type:false,
      target_selector:false,
    }, options), 'component')
    this.bindEvents()
  }
  
    bindEvents()
    {
      this.$el.click((e) => this.clickBehaviourElementClicked(e));
    }

    clickBehaviourElementClicked(e)
    {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
    }

}



/** WEBPACK FOOTER **
 ** ./components/back-to-top.js
 **/